<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>

  <div v-else>
    <h1
        class="ui header"
        style="text-align: center; text-decoration:underline; text-underline-position: under;"
      >
      {{ room.name }}
    </h1>
    
    <div 
      class="ui item pointing menu"
      :class="{two: $auth.check('doctor'), three: $auth.check('employee') || isAdmin()}"
    >
      <a class="item" :class="{ active: currentTab === tabs.first }"
             @click="currentTab = tabs.first">
        <i class="clipboard icon" />
        Visits
      </a>
      <a 
        class="item" 
        :class="{ active: currentTab === tabs.second }"
        @click="currentTab = tabs.second"
        v-if="$auth.check('employee') || isAdmin()"
      >
        <i class="book icon"/>
        Shifts
      </a>
      <a class="item" :class="{ active: currentTab === tabs.third }"
             @click="currentTab = tabs.third">
        <i class="book icon"/>
        Medical machines
      </a>
    </div>
    
    <div style="margin-top: 20px; border-top: 2px solid #092442" class="ui segment">
      <div style="margin-top: 10px;">
        <div class="ui grid" v-if="currentTab === tabs.first">
          <div class="ten wide column">
            <div class="ui form" v-if="!meta.note">
              <div class="field"> 
                <div class="ui fluid input">
                  <input type="text" placeholder="RoomNote" v-model="roomNote">
                </div>
              </div>
              <div class="ui submit button" @click="saveRoomNote()">
                Submit
              </div>
            </div>
            <div v-else> <h2>{{meta.note.note}} </h2></div>
          </div>
          <div class="two wide column"></div>
          <div class="four wide column">
            <div class="ui form">
              <div class="field">
                <label for="date_of_birth"> Day </label>
                <div
                  style="text-align: center"
                  class="ui calendar"
                  :id="'date-of-birth'"
                >
                  <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input
                      type="text"
                      :placeholder="'Day'"
                      readonly=""
                      name="day"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui divider" />
        <keep-alive>
          <visits 
            :patients="meta.patients" 
            :visits="meta.visits"
            :packages="meta.packages"
            :reservations="meta.reservations"
            :transactions="meta.transactions"
            :doctorName="getDoctorName()"
            :reservationVisits="meta.reservation_visits"
            :isRoomShiftInProgress="roomShiftInProgress || isRoomShiftInProgress()"
            :roomId="room.id"
            :key="visitsKey"
            :currentDate="currentDate"
            v-if="currentTab === tabs.first" 
          />
        </keep-alive>
        <shift 
          v-if="currentTab === tabs.second" 
          :medicalMachines="room.medical_machines" 
          :roomId="roomId"
          @current-shift-started="shiftStarted"
          @current-shift-ended="shiftEnded"
        />
        <medicalMachines :medicalMachines="room.medical_machines" v-if="currentTab === tabs.third" :roomId="roomId"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    visits: require('./room_components/Visits').default,
    shift: require('./room_components/Shift').default,
    medicalMachines: require('./room_components/MedicalMachines').default
  },
  props: {
    roomId: { type: Number, required: true }
  },
  data() {
    return {
      tabs: {
        first: 'visits',
        second: 'shifts',
        third: 'medicalMachines'
      },
      currentTab: 'visits',
      meta: {},
      room: {},
      loading: true,
      roomShiftInProgress: false,
      visitsKey: 0,
      currentDate: window.moment(),
      roomNote: ''
    }
  },
  watch: {
    currentDate(newValue, oldValue) {
      if (newValue.toDate().getDay() != oldValue.toDate().getDay()) {
        this.setHomeCurrentDate(newValue)
        this.getRoom()
      }
    },
    currentTab() {
      this.$nextTick(() => {
        $('#date-of-birth').calendar({
          type: 'date',
          onChange: date => {
            this.currentDate = window.moment(date);
          }
        });

        $('#date-of-birth').calendar('set date', new Date(this.currentDate.toDate()));
      })
    }
  },
  mounted() {
    this.currentDate = this.homeCurrentDate
    this.getRoom()
  },
  methods: {
    getRoom() {
      this.loading = true
      this.$http.get(`rooms/${this.roomId}`, {
        params: {
          clinic_id: this.getClinicId(),
          from_date: this.currentDate.startOf('day').toString(),
          to_date: this.currentDate.endOf('day').toString(),
        }
      }).then(response => {
        this.meta = response.data.meta
        this.room = response.data.room
        this.loading = false
        this.$nextTick(() => {
          $('#date-of-birth').calendar({
            type: 'date',
            onChange: date => {
              this.currentDate = window.moment(date);
            }
          });

          $('#date-of-birth').calendar('set date', new Date(this.currentDate.toDate()));
        })
      })
    },
    isRoomShiftInProgress() {
      if (!this.meta.last_room_shifts.length) {
        return false
      }

      const lastShift = this.meta.last_room_shifts[0]
      this.roomShiftInProgress = lastShift.started_at && !lastShift.finished_at
      return this.roomShiftInProgress
    },
    shiftStarted() {
      this.roomShiftInProgress = true
      ++this.visitsKey
      this.$forceUpdate()
    },
    shiftEnded() {
      this.roomShiftInProgress = false
      ++this.visitsKey
      this.$forceUpdate()
    },
    getDoctorName() {
      if (!this.meta.last_room_shifts.length) {
        return null
      }
      return this.doctorsMeta.find(this.meta.last_room_shifts[0].doctor_id).user.name
    },
    saveRoomNote() {
      this.$http.post(`rooms/${this.roomId}/add/note`, {
        date: this.currentDate,
        note: this.roomNote,
        clinic_id: this.getClinicId()
      }).then(response => {
        this.meta.note = response.data
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rooms/Room.vue